import { Control } from "react-hook-form";

import { ui } from "@patient-watch/ui";
import type { LooseRHFField } from "./utils/loose-rhf-field";

interface Recipient {
    user_id: string;
    recipient_key: "TO" | "CC" | "BCC";
    email?: string;
}

interface Props {
    control: Control;
    recipients: Recipient[];
    label: string;
    disabled: boolean;
    type: "email" | "text";
}

const Recipients: React.FC<Props> = ({ type = "email", disabled = true, label, control }) => {
    const rows = (control._formValues as { action_recipients: Recipient[] }).action_recipients ?? [];
    return (
        <>
            {rows
                .filter((r: Recipient) => r.recipient_key === label.toUpperCase())
                .map((recipient: Recipient, index: number) => (
                    <ui.FormField
                        key={index}
                        control={control}
                        name={`action_recipients[${index}].user_id`}
                        data-cy={`action_recipients[${index}].user_id`}
                        render={({ field: _field }: { field: LooseRHFField }) => (
                            <ui.FormItem className="flex items-center space-y-0">
                                <ui.FormLabel className="w-24 text-sm">{label}</ui.FormLabel>
                                <ui.FormControl>
                                    <ui.Input
                                        className="bg-white h-11 text-sm"
                                        disabled={disabled}
                                        type={type}
                                        value={recipient.email}
                                        // {...field}
                                    />
                                </ui.FormControl>
                                <ui.FormMessage />
                            </ui.FormItem>
                        )}
                    />
                ))}
        </>
    );
};

export default Recipients;
